import { useState as _, forwardRef as x, createElement as M, useRef as k, useEffect as h } from "react";
import { jsx as n, jsxs as y } from "react/jsx-runtime";
import { _ as g } from "./index-D_37ItTm.js";
import { R as N } from "./index-2hJuj4UN.js";
import { $ as T } from "./index-C6eS9p6d.js";
import { c as m } from "./index-SYE1cn5_.js";
import { H as R } from "./Heading-BJmz5DVg.js";
import { B as F } from "./Button-CrmHmqjQ.js";
import { X as I } from "./XMarkIcon-DYnAhe7C.js";
function z() {
  const [e, a] = _(!1), [o, t] = _(null);
  return {
    isOpen: e,
    openModal: () => {
      document.body.style.overflow = "hidden", t(document.activeElement), a(!0);
    },
    closeModal: () => {
      o == null || o.focus(), document.body.style.overflow = "", a(!1);
    }
  };
}
const L = /* @__PURE__ */ x((e, a) => {
  var o;
  const { container: t = globalThis == null || (o = globalThis.document) === null || o === void 0 ? void 0 : o.body, ...s } = e;
  return t ? /* @__PURE__ */ N.createPortal(/* @__PURE__ */ M(T.div, g({}, s, {
    ref: a
  })), t) : null;
}), B = L;
function A({
  isOpen: e,
  onClose: a,
  children: o,
  size: t,
  className: s,
  effect: f = "fade",
  mobileFullSize: p = !0,
  scrollBehavior: E = "inside",
  preventClose: l,
  focusFirstElement: $ = !0
}) {
  const u = k(null);
  h(() => {
    if (e) {
      const d = async (r) => {
        r.key === "Escape" && (!l || await l()) && a();
      };
      return document.addEventListener("keydown", d), () => {
        document.removeEventListener("keydown", d);
      };
    }
  }, [e, l, a]);
  const w = async () => {
    (l ? await l() : !0) && a();
  };
  return h(() => {
    if (e) {
      if (!u.current) return;
      const r = u.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ), c = r[0], b = r[r.length - 1];
      c && $ && c.focus();
      const v = (i) => {
        i.key === "Tab" && (i.shiftKey ? document.activeElement === c && (i.preventDefault(), b.focus()) : document.activeElement === b && (i.preventDefault(), c.focus()));
      };
      return document.addEventListener("keydown", v), () => {
        document.removeEventListener("keydown", v);
      };
    }
  }, [e]), e ? /* @__PURE__ */ n(B, { asChild: !0, children: /* @__PURE__ */ y(
    "div",
    {
      ref: u,
      className: m("modal", {
        "modal--mobile-full-size": p
      }),
      children: [
        /* @__PURE__ */ n("div", { className: "modal__overlay", onClick: w }),
        /* @__PURE__ */ n(
          "div",
          {
            className: m("modal__wrapper", {
              "modal__wrapper--full": t === "full"
            }),
            children: /* @__PURE__ */ n(
              "div",
              {
                className: m(
                  "modal__content",
                  `modal__content--${t}`,
                  `modal__content--${f}`,
                  {
                    "modal__content--scroll-inside": E === "inside"
                  },
                  s
                ),
                tabIndex: -1,
                role: "dialog",
                "aria-modal": "true",
                children: o
              }
            )
          }
        )
      ]
    }
  ) }) : null;
}
function O({
  children: e,
  className: a,
  closeModal: o,
  ...t
}) {
  return /* @__PURE__ */ y("div", { className: m("modal__header", a), ...t, children: [
    /* @__PURE__ */ n(R, { as: "h2", variant: "heading-1", children: e || "" }),
    o && /* @__PURE__ */ n(
      F,
      {
        variant: "flat",
        color: "accent",
        size: "md",
        isOnlyIcon: !0,
        onClick: o,
        "aria-label": "Close",
        children: /* @__PURE__ */ n(I, {})
      }
    )
  ] });
}
function G({ children: e }) {
  return /* @__PURE__ */ n("div", { className: "modal__body", children: e });
}
function J({ children: e }) {
  return /* @__PURE__ */ n("div", { className: "modal__footer", children: e });
}
export {
  A as M,
  O as a,
  G as b,
  J as c,
  z as u
};
